import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  // '/puppies' and '/puppies/' are the same page.
  const isActive = (path) => (location.pathname.replace(/\/+$/, '') || '/') === (path.replace(/\/+$/, '') || '/');

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/puppies/', label: 'Available Puppies' },
    { path: '/supplies/', label: 'Pet Supplies' },
    { path: '/care/', label: 'Pet Care' },
    { path: '/blog/', label: 'Blog' },
    { path: '/reviews/', label: 'Reviews' },
    { path: '/about/', label: 'About' },
    { path: '/contact/', label: 'Contact' }
  ];

  return (
    <header
      className="glass-effect sticky top-0 z-50 border-b border-neutral-border"
      style={{ backdropFilter: 'blur(24px)', backgroundColor: 'rgba(255, 255, 255, 0.8)' }}
    >
      <div className="container mx-auto">
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img
              src="/petsmart-logo.png"
              alt="Petsmart Puppies"
              className="h-12 w-12 rounded-full object-cover"
              loading="eager"
            />
            <div>
              {/* Not an <h1>: each page has its own H1; this is the site name. */}
              <span className="block text-xl font-bold" style={{ color: 'var(--primary-main)' }}>
                Petsmart Puppies
              </span>
              <p className="text-xs" style={{ color: 'var(--text-muted)' }}>
                Sector 31, Noida
              </p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="font-medium transition-all hover:scale-105"
                style={{
                  color: isActive(link.path) ? 'var(--primary-main)' : 'var(--text-main)',
                  fontSize: '0.9rem'
                }}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Call Button */}
          <a
            href="tel:+917217648679"
            data-testid="header-call-button"
            className="hidden md:flex items-center gap-2 px-6 py-3 rounded-full font-bold shadow-lg transition-all hover:shadow-xl hover:-translate-y-1"
            style={{
              backgroundColor: 'var(--primary-main)',
              color: 'white'
            }}
          >
            <Phone size={18} />
            Call Now
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2"
            data-testid="mobile-menu-button"
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden pb-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMenuOpen(false)}
                className="block py-3 px-4 font-medium transition-all"
                style={{
                  color: isActive(link.path) ? 'var(--primary-main)' : 'var(--text-main)',
                  backgroundColor: isActive(link.path) ? 'var(--primary-light)' : 'transparent',
                  borderRadius: '0.5rem'
                }}
              >
                {link.label}
              </Link>
            ))}
            <a
              href="tel:+917217648679"
              className="block mt-4 text-center py-3 rounded-full font-bold"
              style={{
                backgroundColor: 'var(--primary-main)',
                color: 'white'
              }}
            >
              Call Now
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;